import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { useAuth } from '../../context/auth'

export const SignOutButton = () => {
  const { logout } = useAuth()

  return (
    <Box>
      <Button variant="contained" color="secondary" onClick={() => logout()}>
        Sign Out
      </Button>
    </Box>
  )
}

export default SignOutButton
